import {Injectable} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
// import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastController } from 'ionic-angular';

@Injectable()
export class APIInterceptor implements HttpInterceptor {

  local: string ;//= localStorage.getItem('Auth');
  //public global: GlobalProvider;
  agencyid: string;// = localStorage.getItem('agencyid');
  contactid: string;

  constructor(private toastCtrl: ToastController){

  }
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    this.local  = localStorage.getItem('Auth');
    this.agencyid = localStorage.getItem('agencyid');
    this.contactid = localStorage.getItem('ContactId');

    var apiReq = req.clone({
       url: `https://mobile.ts-entry.com/api/${req.url}`
    });


    if (req.url != 'login/login_get/' && req.url != 'login/forgot_password/'){

      apiReq = apiReq.clone({
        headers: req.headers.set('Auth', this.local)
        .set('agencyid', this.agencyid)
        .set('contactid', this.contactid)
        .set('Version', "2")
      });

    }

    return next.handle(apiReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // Check if error is 401 Unauthorized
        if (error.status === 401) {
          console.log("!!!!!!!!401 ERROR!!!!!!!")
          // return this.handle401Error(req, next);

          // Show notification to user
          this.showUnauthorizedNotification();
          
          // Redirect to login after short delay
          setTimeout(() => {
            this.redirectToLogin();
          }, 2000);
          
          return;
        }
        
        // For other errors, just re-throw
        // return throwError(error);
        return Observable.throw(error);

      })
    );

    
  }

  private showUnauthorizedNotification(): void {
    // You can use ToastController, AlertController, or any notification service
    console.warn('Session expired. Please login again.');
    
    // Example with ToastController (Ionic)
    // this.presentToast("Session expired. Please login again.")
    this.toastCtrl.create({
      message: 'Session expired. Please login again.',
      duration: 3000,
      position: 'bottom'
    }).present();
  }

  private redirectToLogin(): void {
    localStorage.clear();
    // Use your routing method
    window.location.href = '/';
    
    // or this.router.navigate(['/login']); if using Angular Router
  }

}



// WEBPACK FOOTER //
// ./src/app/APIInterceptor.ts